
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { saveAs } from 'file-saver';
import * as moment from 'moment';
import { NGXLogger } from 'ngx-logger';
import { FileUpload } from 'primeng/components/fileupload/fileupload';
import { Subscription } from 'rxjs';
import { ContractFile } from '../../../models/contract-file.model';
import { Customer } from '../../../models/customer.model';
import { EANCode } from '../../../models/ean-code.model';
import { GasContract } from '../../../models/gas-contract.model';
import { MeterType } from '../../../models/meter-type.model';
import { Permission } from '../../../models/permission.model';
import { SPGasContract } from '../../../models/sp-gas-contract';
import { Supplier } from '../../../models/supplier.model';
import { AccountService } from '../../../services/account.service';
import { AlertService, DialogType, MessageSeverity } from '../../../services/alert.service';
import { fadeInOut } from '../../../services/animations';
import { AuthService } from '../../../services/auth.service';
import { ContractFileService } from '../../../services/contract-file.service';
import { CustomersService } from '../../../services/customers.service';
import { EANCodeService } from '../../../services/ean-code.service';
import { GasContractService } from '../../../services/gas-contract.service';
import { MeterTypeService } from '../../../services/meter-type.service';
import { ScrollService } from '../../../services/scroll.service';
import { SupplierService } from '../../../services/supplier.service';

@Component({
    selector: 'gas-contract',
    template: require('./gas-contract.component.html'),
    styles: [require('./gas-contract.component.css')],
    animations: [fadeInOut]
})

export class GasContractComponent implements OnInit, OnDestroy {
    private subscribers: Subscription[] = [];

    btneditclick: string = "";
    mode: string = "Toevoegen";
    spGasContracts: SPGasContract[] = [];
    gasContract: GasContract = new GasContract();
    gasContracts: GasContract[] = [];
    meterTypes: MeterType[] = [];
    suppliers: any[] = [];
    uploadedFiles: any[] = [];
    dtuploadedFiles: any[] = [];
    loading: boolean = false;
    loadingEndex: boolean = false;
    uploadUrl: string = "api/ContractFile/UploadFile/2"; // 2: Gas
    yearRange: string = (new Date().getFullYear() - 5) + ':' + (new Date().getFullYear() + 30);
    @ViewChild(FileUpload) fileInput: FileUpload;
    eanCodes: EANCode[] = [];
    isEditablePermission: boolean = false;

    constructor(private gasContractService: GasContractService,
        private meterTypeService: MeterTypeService, private supplierService: SupplierService, private contractFileService: ContractFileService,
        private customersService: CustomersService, private eanCodeService: EANCodeService, private accountService: AccountService, private authService: AuthService,
        private router: Router, private activatedRoute: ActivatedRoute, private alertService: AlertService, private ngxLogger: NGXLogger, private scrollService: ScrollService) { }

    ngOnInit(): void {
        this.isEditablePermission = this.cangasContractAddPermission;
        const gcid = this.activatedRoute.snapshot.params["gcid"];
        if (gcid) {
            this.mode = "Bewerk";
        }

        const meterTypeSubscriber = this.meterTypeService.get()
            .subscribe((res: MeterType[]) => {
                this.meterTypes = res;
            }, error => {
                this.ngxLogger.error(error.message);
                throw error;
            });
        this.subscribers.push(meterTypeSubscriber);
        this.setInitValue();
    }

    setInitValue() {
        this.gasContract.ContractBase.FacilityTypeId = 2; // 2: Gas

        const cType = this.activatedRoute.snapshot.params["ctype"];
        if (cType) {
            this.gasContract.CType = cType.toUpperCase();
        }

        const cid = this.activatedRoute.snapshot.params["cid"];
        if (cid) {
            this.gasContract.ContractBase.CustomerId = cid;
            this.getCustomerById();
            this.getEanCodesByCustomerAndEANCodeType();
        }

        const getAllByFCSubscriber = this.supplierService.getAllByFacilityType(2)
            .subscribe((res: Supplier[]) => {
                const _suppliers = new Array<any>();
                res.forEach((s: Supplier) => {
                    _suppliers.push({ label: s.Name, value: s.Id });
                });
                this.suppliers = _suppliers;
                if (this.suppliers && this.suppliers.length > 0 && this.gasContract.Id == 0) {
                    this.gasContract.ContractBase.SupplierId = this.suppliers[0].value;
                }
            }, error => {
                this.ngxLogger.error(error.message);
                throw error;
            });
        this.subscribers.push(getAllByFCSubscriber);

        setTimeout(() => {
            if (cid) {
                this.getAllByCustomer(cid);
            } else {
                this.getAll();
            }
        }, 500);
    }

    getAll() {
        this.loading = true;
        const getAllGSubscriber = this.gasContractService.getAll().subscribe((res: GasContract[]) => {
            if (res != null && res.length > 0) {
                this.gasContracts = res;
            }
            this.loading = false;
            this.setGasContract();
        }, error => {
            this.loading = false;
            this.ngxLogger.error(error.message);
            throw error;
        });
        this.subscribers.push(getAllGSubscriber);
    }

    getAllByCustomer(customerId: number) {
        this.loading = true;
        const GetFilteredSubscriber = this.gasContractService.getFiltered(customerId).subscribe((res: SPGasContract[]) => {
            if (res != null && res.length > 0) {
                this.spGasContracts = res;
            }
            this.loading = false;
            this.setGasContract();
        }, error => {
            this.loading = false;
            this.ngxLogger.error(error.message);
            throw error;
        });
        this.subscribers.push(GetFilteredSubscriber);
    }

    getCustomerById() {
        const getByIdSubscriber = this.customersService.getById(this.gasContract.ContractBase.CustomerId).subscribe((res: Customer) => {
            this.gasContract.ContractBase.Customer = res;
        }, error => {
            this.ngxLogger.error(error.message);
            throw error;
        });
        this.subscribers.push(getByIdSubscriber);
    }

    getEanCodesByCustomerAndEANCodeType() {
        const getEAnCodeSubscriber = this.eanCodeService.getEanCodesByCustomerAndEANCodeType(this.gasContract.ContractBase.CustomerId, 1, this.gasContract.CType).subscribe((res: EANCode[]) => {
            this.gasContract.SourceEanCodes = res;
            this.gasContract.TargetEanCodes = [];
            this.eanCodes = res;
        }, error => {
            this.ngxLogger.error(error.message);
            throw error;
        });
        this.subscribers.push(getEAnCodeSubscriber);
    }

    setGasContract() {
        const gcid = this.activatedRoute.snapshot.params["gcid"];
        if (gcid) {
            this.isEditablePermission = this.cangasContractEditPermission;
            const getVMSubscriber = this.gasContractService.getGasContractVMByContractId(gcid).subscribe((gasContract: GasContract) => {
                if (gasContract) {
                    this.edit(gasContract);
                }
            }, error => {
                this.ngxLogger.error(error.message);
                throw error;
            });
            this.subscribers.push(getVMSubscriber);
        }
    }

    createUpdate(form: NgForm) {
        if (this.isEditablePermission) {
            if (this.gasContract.Id == 0 && this.gasContract.TargetEanCodes.length == 0) {
                this.alertService.showMessage("Aardgas Contracten", "Selecteer alstublieft EAN-code", MessageSeverity.error);
                return false;
            }
            if (this.gasContract.ContractBase && this.gasContract.ContractBase.Customer.ContractBases) {
                this.gasContract.ContractBase.Customer.ContractBases = undefined;
            }
            const cuSubscriber = this.gasContractService.createUpdate(this.gasContract).subscribe((res: GasContract) => {
                if (res) {
                    this.alertService.showMessage('Aardgas Contracten', 'Wijzigingen met succes opgeslagen!', MessageSeverity.success);
                    this.gasContract = res;
                    this.fileInput.url = "api/ContractFile/UploadFile/2/" + res.ContractBaseIds;
                    this.gasContract.ContractBase.ContractDate = moment.utc(this.gasContract.ContractBase.ContractDate).toDate();
                    this.gasContract.ContractBase.ContractStartDate = moment.utc(this.gasContract.ContractBase.ContractStartDate).toDate();
                    this.gasContract.ContractBase.ContractEndDate = moment.utc(this.gasContract.ContractBase.ContractEndDate).toDate();

                    // FILE UPLOADING
                    if (this.fileInput.files.length > 0) {
                        this.fileInput.upload();
                    }

                    // REFRESH CONTRACT FILES
                    // setTimeout(() => {
                    //     this.refreshContractFile(res.Id);
                    // }, 1000);

                    this.resetForm(form);
                    this.setInitValue();
                    this.fileInput.clear();

                    // REFRESH LIST
                    this.getAllByCustomer(this.gasContract.ContractBase.CustomerId);
                }
            }, error => {
                this.ngxLogger.error(error.message);
                throw error;
            });
            this.subscribers.push(cuSubscriber);
        }
    }

    SetEditByID(cid: number) {
        const getVMSubscriber = this.gasContractService.getGasContractVMByContractId(cid).subscribe((gasContract: GasContract) => {
            if (gasContract) {
                this.gasContract = gasContract;
                this.edit(gasContract);
            }
        }, error => {
            this.ngxLogger.error(error.message);
            throw error;
        });
        this.subscribers.push(getVMSubscriber);
    }

    edit(gc: GasContract) {
        this.scrollService.scrollTop();
        this.gasContract = gc;
        this.gasContract.ContractBase.ContractDate = moment.utc(this.gasContract.ContractBase.ContractDate).toDate();
        this.gasContract.ContractBase.ContractStartDate = moment.utc(this.gasContract.ContractBase.ContractStartDate).toDate();
        this.gasContract.ContractBase.ContractEndDate = moment.utc(this.gasContract.ContractBase.ContractEndDate).toDate();
        // getFiles
        this.getContractFiles(gc.ContractBaseId);
        // SET ENDEX
        this.getEndexByDate(this.gasContract.ContractBase.ContractDate, true);

        // FILE UPLOADING
        this.uploadUrl = 'api/ContractFile/UploadFile/2/' + gc.ContractBaseId;
        this.mode = "Bijwerken";

        // REFRESH CONTRACT FILES
        // this.refreshContractFile(gc.Id);
    }

    viewFile(id: number) {
        const getGSVMSubscriber = this.gasContractService.getGasContractVMByContractId(id).subscribe((gasContract: GasContract) => {
            if (gasContract) {
                this.gasContract = gasContract;
                this.alertService.showMessage('Aardgas Contracten', 'Even geduld aub terwijl we een bestand van de server krijgen!', MessageSeverity.info);
                const getALLFCSubscriber = this.contractFileService.getAllByFacility(2, gasContract.ContractBaseId).subscribe((res: any[]) => {
                    if (res.length > 0) {
                        this.alertService.showMessage('Aardgas Contracten', 'Downloaden van bestanden is bezig!', MessageSeverity.info);
                        if (res.length == 1) { // VIEW SINGLE FILE

                            const vfileSubscriber = this.contractFileService.viewFile(2, gasContract.ContractBaseId, res[0].Id).subscribe(data => {
                                const url = window.URL.createObjectURL(data);
                                const iFrameElement = <HTMLIFrameElement>document.getElementById('iFrameContent');
                                iFrameElement.setAttribute('src', url);
                                iFrameElement.setAttribute('type', data.type);
                                (<HTMLButtonElement>document.getElementById('btnmyModelPopup')).click();
                            }, error => {
                                this.ngxLogger.error(error.message);
                                throw error;
                            });
                            this.subscribers.push(vfileSubscriber);
                        } else if (res.length > 1) { // DOWNLOAD ZIP
                            const dzSubscriber = this.gasContractService.downloadZip(2, gasContract.ContractBaseId).subscribe(data => {
                                saveAs(data, 'GasContracts.zip');
                                this.alertService.showMessage('Aardgas Contracten', 'Bestandsdownload voltooid!', MessageSeverity.info);
                            }, error => {
                                this.ngxLogger.error(error.message);
                                throw error;
                            });
                            this.subscribers.push(dzSubscriber);
                        }
                    } else {
                        this.alertService.showMessage('Aardgas Contracten', 'Geen document gevonden voor dit contract!', MessageSeverity.info);
                    }
                }, error => {
                    this.ngxLogger.error(error.message);
                    throw error;
                });
                this.subscribers.push(getALLFCSubscriber);
            }
        }, error => {
            this.ngxLogger.error(error.message);
            throw error;
        });
        this.subscribers.push(getGSVMSubscriber);
    }

    previewFile(cFile: ContractFile) {
        const gsSubscriber = this.gasContractService.getGasContractById(cFile.ContractId).subscribe((gasContract: GasContract) => {
            const vfileSubscriber = this.contractFileService.viewFile(cFile.FacilityTypeId, cFile.ContractBaseId, cFile.Id).subscribe(data => {
                const url = window.URL.createObjectURL(data);
                const iFrameElement = <HTMLIFrameElement>document.getElementById('iFrameContent');
                iFrameElement.setAttribute('src', url);
                iFrameElement.setAttribute('type', data.type);
                (<HTMLButtonElement>document.getElementById('btnmyModelPopup')).click();
            }, error => {
                this.ngxLogger.error(error.message);
                throw error;
            });
            this.subscribers.push(vfileSubscriber);
        });
        this.subscribers.push(gsSubscriber);
    }

    private getFileExtensionFromContentType(contentType: string) {
        let fileExtension: string;
        switch (contentType.toLowerCase()) {
            case 'image/png':
                fileExtension = '.png';
                break;
            case 'image/gif':
                fileExtension = '.gif';
                break;
            case 'image/jpeg':
            case 'image/jpg':
                fileExtension = '.jpg';
                break;
            case 'application/pdf':
                fileExtension = '.pdf';
                break;

            default:
                fileExtension = '.pdf';
                break;
        }
        return fileExtension;
    }

    getContractFiles(contractId: number) {
        const getAllFcSubscriber = this.contractFileService.getAllByFacility(2, contractId).subscribe((res: any[]) => {
            this.dtuploadedFiles = res;
        }, error => {
            this.ngxLogger.error(error.message);
            throw error;
        });
        this.subscribers.push(getAllFcSubscriber);
    }

    deleteContractFile(Id: number, contractId: number, fileName: string, FileNameInternal: string) {
        this.alertService.showDialog('Weet je zeker dat je wilt verwijderen?', DialogType.confirm, () => {
            const removeByIDSubscriber = this.contractFileService.removeById(Id, contractId, fileName, FileNameInternal).subscribe((res: boolean) => {
                this.getContractFiles(contractId);
                this.alertService.showMessage('Contract File', 'Met succes verwijderd!', MessageSeverity.success);
            }, error => {
                this.ngxLogger.error(error.message);
                throw error;
            });
            this.subscribers.push(removeByIDSubscriber);
        });
    }

    // refreshContractFile(contractId: number) {
    //     this.contractFileService.getAllByFacility(2, contractId).subscribe((res: any[]) => {
    //        this.uploadedFiles = res;
    //     }, error => {
    //        this.ngxLogger.error(error.message);
    //        throw error;
    //     });
    // }

    delete(id: number) {
        this.alertService.showDialog('Weet je zeker dat je wilt verwijderen?', DialogType.confirm, () => {
            const deleteSubscriber = this.gasContractService.delete(id).subscribe(res => {
                this.alertService.showMessage('Aardgas Contracten', 'Met succes verwijderd!', MessageSeverity.success);
                this.router.navigate(['gascontract', this.gasContract.CType, this.gasContract.ContractBase.CustomerId]);
                // this.getAllByCustomer(this.gasContract.ContractBase.CustomerId, true);
                // this.gasContract = new GasContract();
            }, error => {
                this.ngxLogger.error(error.message);
                throw error;
            });
            this.subscribers.push(deleteSubscriber);
        });
    }

    resetForm(form: NgForm) {
        this.scrollService.scrollTop();
        form.resetForm();
        this.gasContract = new GasContract;
        this.uploadedFiles = [];
        const cid = this.activatedRoute.snapshot.params["cid"];
        if (cid) {
            this.gasContract.ContractBase.CustomerId = cid;
            this.getCustomerById();
            this.getEanCodesByCustomerAndEANCodeType();
        }
        this.mode = "Toevoegen";
        this.uploadUrl = "api/ContractFile/UploadFile/2"; // 2: Gas

        this.gasContract.ContractBase.SupplierId = this.suppliers[0].value;
        this.gasContract.ContractBase.FacilityTypeId = 2;
    }

    onUpload(event) {
        this.fileInput.clear();
        this.alertService.resetStickyMessage();
        this.alertService.showMessage("Aardgas Contracten", "Bestand succesvol geüpload", MessageSeverity.success);
        for (let file of event.files) {
            this.uploadedFiles.push(file);
        }
        const cid = this.activatedRoute.snapshot.params["cid"];
        if (cid) {
            // REFRESH LIST
            this.getAllByCustomer(cid);
        }
    }

    onProgress(event) {
        this.alertService.resetStickyMessage();
        if (event.progress) {
            this.alertService.showStickyMessage("Aardgas Contracten", `Het uploaden van bestanden is bezig, ${event.progress}% bestandsupload`, MessageSeverity.wait);
        }
    }

    onError(event) {
        this.fileInput.clear();
        this.alertService.resetStickyMessage();
        this.alertService.showStickyMessage("Aardgas Contracten", "Uploaden van bestanden is mislukt", MessageSeverity.warn);
    }

    getSizeInMegaBytes(size: number) {
        return size / 1000000;
    }

    deleteFile(file: any) {
        this.alertService.showDialog('Weet je zeker dat je ' + file.FileName + ' wilt verwijderen?', DialogType.confirm, () => {
            const deleteFileSubscriber = this.contractFileService.delete(file.Id).subscribe(res => {
                if (res) {
                    this.alertService.showMessage('Contract Bestand', 'Met succes verwijderd!', MessageSeverity.success);
                    const index = this.uploadedFiles.indexOf(file);
                    if (index !== -1) {
                        this.uploadedFiles.splice(index, 1);
                    }
                }
            }, error => {
                this.ngxLogger.error(error.message);
                throw error;
            });
            this.subscribers.push(deleteFileSubscriber);
        });
    }

    getEndexByDate(value: Date, isInit: boolean) {
        this.loadingEndex = true;
        const contractDate = moment(value).format("YYYY-MM-DD");
        const getEndexSubscriber = this.gasContractService.getEndexByDate(contractDate).subscribe((res: number) => {
            if (res > 0) {
                if (this.authService.currentUser && this.authService.currentUser.IsTrial) {
                    this.setTrialUserEndex(isInit);
                } else {
                    this.gasContract.Endex = res;
                }
            } else {
                this.gasContract.Endex = null;
                if (!isInit) {
                    this.alertService.showMessage('Aardgas Contracten', 'Geen Endex waarde gevonden voor geselecteerde datum. Gelieve een andere datum te selecteren!', MessageSeverity.error);
                }
            }
            this.loadingEndex = false;
        }, error => {
            this.loadingEndex = false;
            this.ngxLogger.error(error.message);
            throw error;
        });

        this.subscribers.push(getEndexSubscriber);
    }

    private setTrialUserEndex(isInit: boolean) {
        this.loadingEndex = true;
        const contractDate = moment("2016-03-14").format("YYYY-MM-DD");
        const getEndexDateSubscriber = this.gasContractService.getEndexByDate(contractDate).subscribe((res: number) => {
            if (res > 0) {
                this.gasContract.Endex = res;
            } else {
                this.gasContract.Endex = null;
                if (!isInit) {
                    this.alertService.showMessage('Aardgas Contracten', 'Geen Endex waarde gevonden voor geselecteerde datum. Gelieve een andere datum te selecteren!', MessageSeverity.error);
                }
            }
            this.loadingEndex = false;
        }, error => {
            this.loadingEndex = false;
            this.ngxLogger.error(error.message);
            throw error;
        });
        this.subscribers.push(getEndexDateSubscriber);
    }

    onDateChange(value: Date) {
        if (moment(value).isAfter(this.gasContract.ContractBase.ContractStartDate)) {
            this.gasContract.ContractBase.ContractStartDate = value;
        }
    }

    onStartDateChange(value: Date) {
        if (moment(value).isAfter(this.gasContract.ContractBase.ContractEndDate)) {
            this.gasContract.ContractBase.ContractEndDate = value;
        }
    }

    mySatSunDateFilter = (d: any): boolean => {
        const day = d.toDate().getDay();
        // Prevent Saturday and Sunday from being selected.
        return day !== 0 && day !== 6;
    }

    ngOnDestroy() {
        if (this.subscribers) {
            this.subscribers.forEach(s => s.unsubscribe());
        }
    }

    showErrorAlert(caption: string, message: string) {
        this.alertService.showMessage(caption, message, MessageSeverity.error);
    }

    get cangasContractAddPermission() {
        return this.accountService.userHasPermission(Permission.gasContractAddPermission);
    }

    get cangasContractEditPermission() {
        return this.accountService.userHasPermission(Permission.gasContractEditPermission);
    }

    get cangasContractDeletePermission() {
        return this.accountService.userHasPermission(Permission.gasContractDeletePermission);
    }

    get cangasContractViewPermission() {
        return this.accountService.userHasPermission(Permission.gasContractViewPermission);
    }

    get cangasContractListPermission() {
        return this.accountService.userHasPermission(Permission.gasContractListPermission);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/gas/gas-contract/gas-contract.component.ts